import React from "react"
import PropTypes from "prop-types"
import { renderHtmlWithLegalPrivacyTable } from "../../../utils/renderHtmlWithLegalPrivacyTable"
import * as css from "./Faq.module.css"

const Faq = ({ questions }) => {
  return (
    <div className={`${css.wrapper} faq`}>
      {questions.map((faq, i) => (
        <details key={i} className={css.item}>
          <summary className={css.question}>
            <span className={css.icon} aria-hidden="true" />
            <span className={css.questionText}>{faq.question}</span>
          </summary>
          <div className={css.body}>
            {renderHtmlWithLegalPrivacyTable(faq.answer)}
          </div>
        </details>
      ))}
    </div>
  )
}

Faq.propTypes = {
  questions: PropTypes.array,
}

export { Faq }
